import i18n from 'i18next';

export const createi18nStaticTranslator = (translationsPre: string) => ({
  t(translation: string) {
    const tlWithPre = `${translationsPre}${translation}`;
    const fallback = i18n.t(translation);

    return i18n.t(tlWithPre, fallback);
  }
});
